import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/MyExperience.css';
import Resume from '../images/resume.png';
import DownloadIcon from '../images/Download.svg';
import ResumeFile from '../Michelle_Maltbia_Resume.pdf';

const MyExperience = () => {
  return (
    <section id="experience" className="my-experience-section py-5 position-relative">
      <div className="container">
        {/* Standard Section Header */}
        <div className="my-experience-header text-start mb-5">
          <h1 className="my-experience-main-title mb-3">My Experience</h1>
          <p className="my-experience-subtitle">
            Designing and shipping enterprise products at scale—backed by measurable impact.
          </p>
        </div>

        <div className="row align-items-center">
          {/* Left Side: Resume Image */}
          <div className="col-12 col-md-5 text-center mb-4 mb-md-0">
            <div className="row">
              <img
                src={Resume}
                alt="Resume"
                className="img-fluid resume-image"
              />
            </div>
            <div className="download-resume mt-3">
              <a href={ResumeFile} download className="text-dark text-decoration-none">
                <img src={DownloadIcon} alt="Download Icon" className="me-2" />
                Download Resume
              </a>
            </div>
          </div>

          {/* Right Side: Experience Text */}
          <div className="col-12 col-md-7 ps-md-5">
            <h2 className="experience-title mb-3">
              11+ years of Design &amp; Development Experience
            </h2>
            <p className="experience-description mb-4">
              Each project showcased here reflects my dedication to crafting user-centered designs that blend empathy, functionality, and aesthetics. My expertise spans design systems, front-end development, and cross-functional collaboration to deliver impactful, high-quality solutions. Let’s explore how my work can drive meaningful results for users and businesses alike.
            </p>
            <div className="role-tags d-flex gap-2 mt-4 flex-wrap">
              <span className="role-tag">Front-End Engineer</span>
              <span className="role-tag">UX Designer</span>
              <span className="role-tag">Design Technologist</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyExperience;
